import React from 'react';
import { Check, ShieldCheck, Lock, Zap } from 'lucide-react';
interface PricingProps {
  checkoutUrl: string;
}
export function Pricing({
  checkoutUrl
}: PricingProps) {
  return <section id="pricing-section" className="py-16 md:py-24 bg-gray-50 px-4" data-id="element-152">
      <div className="max-w-lg mx-auto" data-id="element-153">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-154">
          {/* Header */}
          <div className="bg-gray-900 p-6 text-center text-white" data-id="element-155">
            <h3 className="text-xl font-bold tracking-wide" data-id="element-156">
              Oferta Especial Hoy
            </h3>
          </div>

          <div className="p-8 md:p-10" data-id="element-157">
            {/* Price */}
            <div className="text-center mb-8" data-id="element-158">
              <p className="text-gray-400 text-lg mb-1 line-through" data-id="element-159">
                ARS $49.990
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-160">
                <span className="text-5xl font-black text-gray-900 tracking-tight" data-id="element-161">
                  ARS $19.990
                </span>
              </div>
              <p className="text-sm text-green-600 font-bold mt-2 bg-green-50 inline-block px-3 py-1 rounded-full" data-id="element-162">
                Ahorrás 60% HOY
              </p>
            </div>

            {/* Checklist */}
            <div className="space-y-4 mb-10" data-id="element-163">
              <div className="flex items-start gap-3" data-id="element-164">
                <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-165">
                  <Check className="w-4 h-4 text-green-600" data-id="element-166" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-167">
                  Programa completo (5 Tomos)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-168">
                <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-169">
                  <Check className="w-4 h-4 text-green-600" data-id="element-170" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-171">
                  Bono 1: Guía de hábitos sanos
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-172">
                <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-173">
                  <Check className="w-4 h-4 text-green-600" data-id="element-174" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-175">
                  Bono 2: Concentración sin celular
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-176">
                <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-177">
                  <Check className="w-4 h-4 text-green-600" data-id="element-178" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-179">
                  Bono 3: Actividades familiares
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-180">
                <div className="bg-blue-100 p-1 rounded-full mt-0.5" data-id="element-181">
                  <Zap className="w-4 h-4 text-blue-600" data-id="element-182" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-183">
                  Acceso inmediato de por vida
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-184">
                <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-185">
                  <Lock className="w-4 h-4 text-green-600" data-id="element-186" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-187">
                  Pago 100% seguro
                </span>
              </div>
            </div>

            {/* Value phrase */}
            <p className="text-center text-lg font-semibold text-gray-800 mb-4" data-id="element-188">
              Quiero obtener la saga completa con los bonos
            </p>

            {/* CTA */}
            <a href={checkoutUrl} className="block w-full bg-red-600 hover:bg-red-700 text-white text-xl font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all text-center mb-6" data-id="element-189">
              Comprar ahora
            </a>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500 font-medium" data-id="element-190">
              <div className="flex items-center gap-1.5" data-id="element-191">
                <Lock className="w-4 h-4 text-gray-400" data-id="element-192" />
                <span data-id="element-193">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-194">
                <ShieldCheck className="w-4 h-4 text-gray-400" data-id="element-195" />
                <span data-id="element-196">Garantía 7 Días</span>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center text-gray-400 text-sm mt-6" data-id="element-197">
          Producto digital · Acceso inmediato · Un solo pago
        </p>
      </div>
    </section>;
}